export default __webpack_public_path__ + "static/media/035-padlock-1.97644b76.png";